import { render, staticRenderFns } from "./d-submit-your-book.vue?vue&type=template&id=44d02b3e&"
import script from "./d-submit-your-book.vue?vue&type=script&lang=js&"
export * from "./d-submit-your-book.vue?vue&type=script&lang=js&"
import style0 from "./d-submit-your-book.vue?vue&type=style&index=0&id=44d02b3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports